function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread();
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray(r);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var Template = require('./chain-viewer.template');
var _require = require('../peer/client'),
  sendExplorerPeerRequest = _require.sendExplorerPeerRequest;
var SPACING = 3;
var COLORS = {
  canonical: 0x41bfac,
  fork: 0xf0ac55,
  unknown: 0x8994ad,
  selected: 0xe64c65
};
var chainStatus = function chainStatus(block) {
  return block.in_longest_chain === 1 ? 'canonical' : block.in_longest_chain === 0 ? 'fork' : 'unknown';
};
var ChainViewer = /*#__PURE__*/function () {
  function ChainViewer(app, mod) {
    var anchor = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, ChainViewer);
    this.app = app;
    this.mod = mod;
    this.anchor = anchor;
    this.blocks = new Map();
    this.lanes = new Map();
    this.coverage = new Map();
    this.center = null;
    this.vertical = 0;
    this.scale = 32;
    this.selected = null;
    this.disposed = false;
    this.loading = false;
    this.waiters = new Set();
    this.controller = new AbortController();
  }
  return _createClass(ChainViewer, [{
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(container) {
        var _this = this;
        var message, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              this.app.browser.replaceElementContentBySelector(Template(), container);
              this.root = document.querySelector('.explorer-chain');
              this.stage = this.root.querySelector('.explorer-chain-stage');
              this.labels = this.root.querySelector('.explorer-chain-labels');
              this.attachEvents();
              this.status('Loading chain…');
              _context.p = 1;
              _context.n = 2;
              return import('three');
            case 2:
              this.THREE = _context.v;
              if (!this.disposed) {
                _context.n = 3;
                break;
              }
              return _context.a(2);
            case 3:
              this.setupScene();
              _context.n = 5;
              break;
            case 4:
              _context.p = 4;
              _t = _context.v;
              this.stage.classList.add('without-webgl');
              this.stage.setAttribute('aria-label', '3D unavailable. Use the block list below.');
              this.root.querySelector('details').open = true;
              message = document.createElement('p');
              message.textContent = '3D view unavailable. Browse the block list below.';
              this.stage.append(message);
            case 5:
              if (!this.disposed) {
                _context.n = 6;
                break;
              }
              return _context.a(2);
            case 6:
              this.resizeObserver = new ResizeObserver(function () {
                return _this.draw();
              });
              this.resizeObserver.observe(this.stage);
              this.refresh();
            case 7:
              return _context.a(2);
          }
        }, _callee, this, [[1, 4]]);
      }));
      function render(_x) {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "setupScene",
    value: function setupScene() {
      var T = this.THREE;
      this.renderer = new T.WebGLRenderer({
        antialias: true,
        alpha: true
      });
      this.renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
      this.stage.prepend(this.renderer.domElement);
      this.scene = new T.Scene();
      this.camera = new T.OrthographicCamera(-10, 10, 6, -6, 0.1, 100);
      this.camera.position.set(0, 0, 25);
      this.scene.add(new T.AmbientLight(0xffffff, 2));
      var light = new T.DirectionalLight(0xffffff, 3);
      light.position.set(-3, 8, 12);
      this.scene.add(light);
      this.geometry = new T.BoxGeometry(1, 1, 1);
      this.material = new T.MeshStandardMaterial({
        roughness: 0.65,
        metalness: 0.1
      });
      this.lineMaterial = new T.LineBasicMaterial({
        color: 0x798a9b,
        transparent: true,
        opacity: 0.55
      });
      this.raycaster = new T.Raycaster();
    }
  }, {
    key: "status",
    value: function status(text) {
      if (!this.disposed) this.root.querySelector('[data-chain-status]').textContent = text;
    }
  }, {
    key: "request",
    value: function request(params) {
      var _this2 = this;
      return new Promise(function (resolve, reject) {
        var finish = function finish(err, value) {
          clearTimeout(timer);
          _this2.waiters["delete"](cancel);
          err ? reject(err) : resolve(value);
        };
        var cancel = function cancel() {
          return finish(new Error('Viewer closed'));
        };
        var timer = setTimeout(function () {
          return finish(new Error('Request timed out. Use Refresh to retry.'));
        }, 20000);
        _this2.waiters.add(cancel);
        try {
          sendExplorerPeerRequest(_this2.app, 'request chain', {
            peer: _this2.mod.explorerPeer,
            data: _objectSpread({
              request: 'request chain'
            }, params),
            callback: function callback(response) {
              return response !== null && response !== void 0 && response.success ? finish(null, response.data) : finish(new Error((response === null || response === void 0 ? void 0 : response.error) || 'Unable to load chain'));
            }
          });
        } catch (err) {
          finish(err);
        }
      });
    }
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var force,
          from,
          to,
          _this$visibleRange,
          _this$visibleRange2,
          left,
          right,
          covered,
          h,
          indexing,
          requestedCenter,
          params,
          data,
          rows,
          _iterator,
          _step,
          _step$value,
          hash,
          block,
          _iterator2,
          _step2,
          _block,
          _h,
          _iterator3,
          _step3,
          _step3$value,
          _hash,
          _block2,
          _iterator4,
          _step4,
          _h2,
          _args2 = arguments,
          _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              force = _args2.length > 0 && _args2[0] !== undefined ? _args2[0] : true;
              if (!(this.disposed || this.loading)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              clearTimeout(this.pollTimer);
              if (this.mod.explorerPeer) {
                _context2.n = 2;
                break;
              }
              this.status('Waiting for an Explorer peer…');
              return _context2.a(2);
            case 2:
              from = this.center == null ? null : Math.max(1, Math.floor(this.center) - 24);
              to = from == null ? null : from + 49;
              if (!(!force && from != null)) {
                _context2.n = 3;
                break;
              }
              _this$visibleRange = this.visibleRange(), _this$visibleRange2 = _slicedToArray(_this$visibleRange, 2), left = _this$visibleRange2[0], right = _this$visibleRange2[1];
              covered = true;
              for (h = left; h <= right; h++) {
                if (Date.now() - (this.coverage.get(h) || 0) > 15000) covered = false;
              }
              if (!covered) {
                _context2.n = 3;
                break;
              }
              this.pollTimer = setTimeout(function () {
                return _this3.refresh();
              }, 15000);
              return _context2.a(2);
            case 3:
              this.loading = true;
              this.status('Loading block metadata…');
              indexing = false;
              requestedCenter = this.center;
              _context2.p = 4;
              params = from == null ? this.anchor ? {
                anchor: this.anchor
              } : {} : {
                from: from,
                to: to
              };
              _context2.n = 5;
              return this.request(params);
            case 5:
              data = _context2.v;
              if (!this.disposed) {
                _context2.n = 6;
                break;
              }
              return _context2.a(2);
            case 6:
              if (!(data.pending_anchor || data.anchor_missing)) {
                _context2.n = 7;
                break;
              }
              indexing = data.pending_anchor;
              this.status(data.disk_error || (data.pending_anchor ? "Finding block on disk\u2026 ".concat(data.scanned_files, " files checked") : 'Block not found in memory, the index or local disk. Import its archive to browse it.'));
              return _context2.a(2);
            case 7:
              if (this.center == null) {
                this.center = data.center || data.tip_height || data.from;
                this.selected = data.selected_hash || data.tip_hash;
                this.centerSelection = true;
              }
              // Accumulate complete pages before replacing a window, including siblings
              // beyond the per-response cap. Never infer completeness from row count.
              rows = _toConsumableArray(data.blocks);
            case 8:
              if (!(data.continuation && !this.disposed)) {
                _context2.n = 10;
                break;
              }
              _context2.n = 9;
              return this.request(_objectSpread({
                from: data.from,
                to: data.to
              }, data.continuation));
            case 9:
              data = _context2.v;
              rows.push.apply(rows, _toConsumableArray(data.blocks));
              _context2.n = 8;
              break;
            case 10:
              if (!this.disposed) {
                _context2.n = 11;
                break;
              }
              return _context2.a(2);
            case 11:
              _iterator = _createForOfIteratorHelper(this.blocks);
              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _step$value = _slicedToArray(_step.value, 2), hash = _step$value[0], block = _step$value[1];
                  if (block.height >= data.from && block.height <= data.to) this.blocks["delete"](hash);
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }
              _iterator2 = _createForOfIteratorHelper(rows);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  _block = _step2.value;
                  this.blocks.set(_block.hash, _block);
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              if (this.centerSelection) {
                this.layout();
                this.vertical = Math.max(0, (this.lanes.get(this.selected) || 0) - 1) * 2.5;
                this.centerSelection = false;
              }
              for (_h = data.from; _h <= data.to; _h++) this.coverage.set(_h, Date.now());
              _iterator3 = _createForOfIteratorHelper(this.blocks);
              try {
                for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                  _step3$value = _slicedToArray(_step3.value, 2), _hash = _step3$value[0], _block2 = _step3$value[1];
                  if (Math.abs(_block2.height - this.center) > 200 && _hash !== this.selected) {
                    this.blocks["delete"](_hash);
                    this.lanes["delete"](_hash);
                  }
                }
              } catch (err) {
                _iterator3.e(err);
              } finally {
                _iterator3.f();
              }
              _iterator4 = _createForOfIteratorHelper(this.coverage.keys());
              try {
                for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
                  _h2 = _step4.value;
                  if (Math.abs(_h2 - this.center) > 200) this.coverage["delete"](_h2);
                }
              } catch (err) {
                _iterator4.e(err);
              } finally {
                _iterator4.f();
              }
              indexing = data.indexing;
              this.tip = data.tip_height;
              this.draw();
              this.showDetails();
              this.status(data.disk_error || (indexing ? "Discovering older blocks\u2026 ".concat(data.scanned_files, " disk files checked. More forks may appear.") : "Local disk discovery complete".concat(data.scan_errors ? "; ".concat(data.scan_errors, " files could not be read") : '', ". Archive imports extend this history.")));
              _context2.n = 13;
              break;
            case 12:
              _context2.p = 12;
              _t2 = _context2.v;
              this.status(_t2.message);
            case 13:
              _context2.p = 13;
              this.loading = false;
              if (!this.disposed) {
                if (requestedCenter != null && Math.abs(this.center - requestedCenter) > 8) {
                  this.pollTimer = setTimeout(function () {
                    return _this3.refresh(false);
                  }, 0);
                } else this.pollTimer = setTimeout(function () {
                  return _this3.refresh();
                }, indexing ? 2000 : 15000);
              }
              return _context2.f(13);
            case 14:
              return _context2.a(2);
          }
        }, _callee2, this, [[4, 12, 13, 14]]);
      }));
      function refresh() {
        return _refresh.apply(this, arguments);
      }
      return refresh;
    }()
  }, {
    key: "visibleRange",
    value: function visibleRange() {
      var half = this.stage.clientWidth / (2 * this.scale * SPACING);
      return [Math.max(1, Math.floor((this.center || 1) - half - 1)), Math.ceil((this.center || 1) + half + 1)];
    }
  }, {
    key: "layout",
    value: function layout() {
      var used = new Map();
      var ordered = _toConsumableArray(this.blocks.values()).sort(function (a, b) {
        return a.height - b.height || (b.in_longest_chain === 1) - (a.in_longest_chain === 1) || a.hash.localeCompare(b.hash);
      });
      var _iterator5 = _createForOfIteratorHelper(ordered),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var _ref, _this$lanes$get;
          var block = _step5.value;
          if (!used.has(block.height)) used.set(block.height, new Set());
          var occupied = used.get(block.height);
          var lane = block.in_longest_chain === 1 ? 0 : (_ref = (_this$lanes$get = this.lanes.get(block.hash)) !== null && _this$lanes$get !== void 0 ? _this$lanes$get : this.lanes.get(block.parent_hash)) !== null && _ref !== void 0 ? _ref : 1;
          if (block.in_longest_chain !== 1 && lane === 0) lane = 1;
          while (occupied.has(lane)) lane++;
          occupied.add(lane);
          this.lanes.set(block.hash, lane);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      var _this4 = this;
      if (this.disposed || this.center == null) return;
      this.layout();
      var _this$visibleRange3 = this.visibleRange(),
        _this$visibleRange4 = _slicedToArray(_this$visibleRange3, 2),
        left = _this$visibleRange4[0],
        right = _this$visibleRange4[1];
      this.visible = _toConsumableArray(this.blocks.values()).filter(function (b) {
        return b.height >= left && b.height <= right;
      });
      var width = this.stage.clientWidth;
      var height = this.stage.clientHeight;
      this.labels.replaceChildren();
      for (var h = left; h <= right; h++) {
        var label = document.createElement('span');
        label.textContent = h.toLocaleString();
        label.style.left = "".concat(width / 2 + (h - this.center) * SPACING * this.scale, "px");
        this.labels.append(label);
      }
      if (this.renderer) {
        var T = this.THREE;
        this.renderer.setSize(width, height, false);
        Object.assign(this.camera, {
          left: -width / (2 * this.scale),
          right: width / (2 * this.scale),
          top: height / (2 * this.scale),
          bottom: -height / (2 * this.scale)
        });
        this.camera.updateProjectionMatrix();
        if (this.mesh) {
          this.scene.remove(this.mesh);
          this.mesh.dispose();
        }
        if (this.lines) {
          this.scene.remove(this.lines);
          this.lines.geometry.dispose();
        }
        this.mesh = new T.InstancedMesh(this.geometry, this.material, this.visible.length);
        var object = new T.Object3D();
        var edges = [];
        var position = function position(block) {
          return new T.Vector3((block.height - _this4.center) * SPACING, 2 - (_this4.lanes.get(block.hash) || 0) * 2.5 + _this4.vertical, 0);
        };
        this.visible.forEach(function (block, i) {
          object.position.copy(position(block));
          object.rotation.set(0.3, -0.45, 0);
          object.updateMatrix();
          _this4.mesh.setMatrixAt(i, object.matrix);
          _this4.mesh.setColorAt(i, new T.Color(block.hash === _this4.selected ? COLORS.selected : COLORS[chainStatus(block)]));
          var parent = _this4.blocks.get(block.parent_hash);
          if (parent) edges.push(position(parent), position(block));
        });
        this.mesh.computeBoundingSphere();
        this.scene.add(this.mesh);
        this.lines = new T.LineSegments(new T.BufferGeometry().setFromPoints(edges), this.lineMaterial);
        this.scene.add(this.lines);
        this.renderer.render(this.scene, this.camera);
      }
      var list = this.root.querySelector('[data-chain-list]');
      list.replaceChildren();
      var _iterator6 = _createForOfIteratorHelper(_toConsumableArray(this.visible).sort(function (a, b) {
          return a.height - b.height || _this4.lanes.get(a.hash) - _this4.lanes.get(b.hash);
        })),
        _step6;
      try {
        for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
          var block = _step6.value;
          var button = document.createElement('button');
          button.type = 'button';
          button.dataset.chainHash = block.hash;
          button.textContent = "".concat(block.height, " \xB7 ").concat(block.hash.slice(0, 12), " \xB7 ").concat(chainStatus(block), " \xB7 ").concat(this.summary(block));
          list.append(button);
        }
      } catch (err) {
        _iterator6.e(err);
      } finally {
        _iterator6.f();
      }
    }
  }, {
    key: "summary",
    value: function summary(block) {
      var count = block.tx_count == null ? 'count unknown' : "".concat(block.tx_count, " tx");
      var size = block.size_bytes == null ? 'size unknown' : "".concat(block.size_bytes.toLocaleString(), " bytes");
      return "".concat(count, " \xB7 ").concat(size);
    }
  }, {
    key: "pick",
    value: function pick(event) {
      if (!this.mesh || !this.raycaster) return null;
      var rect = this.stage.getBoundingClientRect();
      this.raycaster.setFromCamera(new this.THREE.Vector2((event.clientX - rect.left) / rect.width * 2 - 1, -((event.clientY - rect.top) / rect.height) * 2 + 1), this.camera);
      var hit = this.raycaster.intersectObject(this.mesh)[0];
      return hit ? this.visible[hit.instanceId] : null;
    }
  }, {
    key: "select",
    value: function select(hash) {
      this.selected = hash;
      var lane = this.lanes.get(hash) || 0;
      if (Math.abs(2 - lane * 2.5 + this.vertical) > this.stage.clientHeight / (2 * this.scale) - 1) {
        this.vertical = lane * 2.5 - 2;
      }
      window.history.replaceState({
        view: 'chain',
        input: hash
      }, '', "/".concat(this.mod.slug, "/chain/").concat(hash));
      this.showDetails();
      this.draw();
    }
  }, {
    key: "showDetails",
    value: function showDetails() {
      var _this5 = this;
      var block = this.blocks.get(this.selected);
      if (!block) return;
      var panel = this.root.querySelector('.explorer-chain-detail');
      panel.replaceChildren();
      var title = document.createElement('h2');
      title.textContent = "Block ".concat(block.height, " \xB7 ").concat(chainStatus(block));
      var text = document.createElement('p');
      text.textContent = "".concat(this.summary(block), " \xB7 ").concat(new Date(block.timestamp).toLocaleString());
      var hash = document.createElement('p');
      hash.textContent = block.hash;
      var creator = document.createElement('p');
      creator.textContent = "Producer: ".concat(block.creator);
      var link = document.createElement('a');
      link.className = 'explorer-link';
      link.href = "/".concat(this.mod.slug, "/block/").concat(block.hash);
      link.textContent = 'Open in Explorer';
      link.onclick = function (event) {
        event.preventDefault();
        _this5.mod.renderBlock(block.hash);
      };
      var parent = document.createElement('button');
      parent.type = 'button';
      parent.textContent = 'Follow parent ←';
      parent.disabled = /^0+$/.test(block.parent_hash);
      parent.onclick = function () {
        return _this5.mod.renderChain(block.parent_hash);
      };
      panel.append(title, text, hash, creator, link, parent);
      if (!block.body_available) {
        var note = document.createElement('p');
        note.textContent = 'Metadata retained; full block data may be unavailable.';
        panel.append(note);
      }
    }
  }, {
    key: "pan",
    value: function pan(delta) {
      var _this6 = this;
      var vertical = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      this.center = Math.max(1, (this.center || 1) + delta);
      this.vertical += vertical;
      this.draw();
      clearTimeout(this.panTimer);
      this.panTimer = setTimeout(function () {
        return _this6.refresh(false);
      }, 180);
    }
  }, {
    key: "zoom",
    value: function zoom(factor) {
      this.scale = Math.max(16, Math.min(80, this.scale * factor));
      this.pan(0);
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this7 = this;
      var options = {
        signal: this.controller.signal
      };
      this.root.addEventListener('click', function (event) {
        var _event$target$closest, _event$target$closest2;
        var hash = (_event$target$closest = event.target.closest('[data-chain-hash]')) === null || _event$target$closest === void 0 ? void 0 : _event$target$closest.dataset.chainHash;
        if (hash) {
          _this7.select(hash);
          return;
        }
        var action = (_event$target$closest2 = event.target.closest('[data-chain-action]')) === null || _event$target$closest2 === void 0 ? void 0 : _event$target$closest2.dataset.chainAction;
        if (action === 'older') _this7.pan(-10);
        if (action === 'newer') _this7.pan(10);
        if (action === 'zoom-in') _this7.zoom(1.25);
        if (action === 'zoom-out') _this7.zoom(0.8);
        if (action === 'refresh') _this7.refresh();
        if (action === 'latest') _this7.mod.renderChain();
      }, options);
      this.root.querySelector('form').addEventListener('submit', function (event) {
        event.preventDefault();
        var value = new FormData(event.target).get('block').trim();
        if (/^(\d+|[a-f0-9]{64})$/i.test(value)) _this7.mod.renderChain(value);else _this7.status('Enter a block height or a 64-character block hash.');
      }, options);
      this.stage.addEventListener('pointerdown', function (event) {
        if (event.button !== 0 || _this7.center == null) return;
        _this7.drag = {
          x: event.clientX,
          y: event.clientY,
          moved: 0
        };
        _this7.stage.setPointerCapture(event.pointerId);
      }, options);
      this.stage.addEventListener('pointermove', function (event) {
        var tooltip = _this7.root.querySelector('.explorer-chain-tooltip');
        if (_this7.drag) {
          var dx = event.clientX - _this7.drag.x;
          var dy = event.clientY - _this7.drag.y;
          _this7.drag.moved += Math.abs(dx) + Math.abs(dy);
          _this7.drag.x = event.clientX;
          _this7.drag.y = event.clientY;
          if (_this7.drag.moved > 5) _this7.pan(-dx / (_this7.scale * SPACING), -dy / _this7.scale);
          tooltip.hidden = true;
        } else {
          var block = _this7.pick(event);
          tooltip.hidden = !block;
          if (block) tooltip.textContent = "#".concat(block.height, " \xB7 ").concat(block.hash.slice(0, 12), " \xB7 ").concat(_this7.summary(block));
        }
      }, options);
      this.stage.addEventListener('pointerup', function (event) {
        if (_this7.drag && _this7.drag.moved <= 5) {
          var block = _this7.pick(event);
          if (block) _this7.select(block.hash);
        }
        _this7.drag = null;
        if (_this7.stage.hasPointerCapture(event.pointerId)) _this7.stage.releasePointerCapture(event.pointerId);
      }, options);
      this.stage.addEventListener('pointercancel', function () {
        _this7.drag = null;
      }, options);
      this.stage.addEventListener('wheel', function (event) {
        event.preventDefault();
        _this7.zoom(event.deltaY > 0 ? 0.9 : 1.1);
      }, _objectSpread(_objectSpread({}, options), {}, {
        passive: false
      }));
      this.stage.addEventListener('keydown', function (event) {
        if (['ArrowLeft', 'ArrowRight', 'ArrowUp', 'ArrowDown', '+', '-', '='].includes(event.key)) event.preventDefault();
        if (event.key === 'ArrowLeft') _this7.pan(-3);
        if (event.key === 'ArrowRight') _this7.pan(3);
        if (event.key === 'ArrowUp') _this7.pan(0, -2.5);
        if (event.key === 'ArrowDown') _this7.pan(0, 2.5);
        if (event.key === '+' || event.key === '=') _this7.zoom(1.25);
        if (event.key === '-') _this7.zoom(0.8);
      }, options);
    }
  }, {
    key: "cleanup",
    value: function cleanup() {
      var _this$resizeObserver, _this$mesh, _this$geometry, _this$material, _this$lines, _this$lineMaterial, _this$renderer, _this$renderer2;
      this.disposed = true;
      this.controller.abort();
      clearTimeout(this.pollTimer);
      clearTimeout(this.panTimer);
      (_this$resizeObserver = this.resizeObserver) === null || _this$resizeObserver === void 0 || _this$resizeObserver.disconnect();
      for (var _i = 0, _arr = _toConsumableArray(this.waiters); _i < _arr.length; _i++) {
        var cancel = _arr[_i];
        cancel();
      }
      (_this$mesh = this.mesh) === null || _this$mesh === void 0 || _this$mesh.dispose();
      (_this$geometry = this.geometry) === null || _this$geometry === void 0 || _this$geometry.dispose();
      (_this$material = this.material) === null || _this$material === void 0 || _this$material.dispose();
      (_this$lines = this.lines) === null || _this$lines === void 0 || _this$lines.geometry.dispose();
      (_this$lineMaterial = this.lineMaterial) === null || _this$lineMaterial === void 0 || _this$lineMaterial.dispose();
      (_this$renderer = this.renderer) === null || _this$renderer === void 0 || _this$renderer.dispose();
      (_this$renderer2 = this.renderer) === null || _this$renderer2 === void 0 || _this$renderer2.forceContextLoss();
    }
  }]);
}();
module.exports = ChainViewer;